import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import './styles/NotFound.css'; // Optional if you want to add custom styles

const NotFound = () => {

  useEffect(() => {
    document.title = 'Nzubo | Page Not Found';
  }, []); 

  return (
    <div className="not-found-container">
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="back-home-link">Go back to Home</Link>
    </div>
  );
};

export default NotFound;
